'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasEmailCapturePromptFromCurrentSession = undefined;

var _isEmailCapturePromptMessage = require('conversations-schema/pubnub-message/operators/isEmailCapturePromptMessage');

var _getMessageIsApproximatelyFromCurrentSession = require('conversations-schema/pubnub-message/operators/getMessageIsApproximatelyFromCurrentSession');

var _hasMessages = require('conversations-schema/thread-history/operators/hasMessages');

var _getMessages = require('conversations-schema/thread-history/operators/getMessages');

var hasEmailCapturePromptFromCurrentSession = exports.hasEmailCapturePromptFromCurrentSession = function hasEmailCapturePromptFromCurrentSession(threadHistory) {
  if (!(0, _hasMessages.hasMessages)(threadHistory)) {
    return false;
  }

  var messages = (0, _getMessages.getMessages)(threadHistory);

  var lastEmailCaptureMessage = messages.findLast(_isEmailCapturePromptMessage.isEmailCapturePromptMessage);

  return !!(lastEmailCaptureMessage && (0, _getMessageIsApproximatelyFromCurrentSession.getMessageIsApproximatelyFromCurrentSession)(lastEmailCaptureMessage));
};